// Componente que renderiza un modal, este es llamado por cualquier componente que lo necesite
import { useEffect } from "react";
import { FaCircleXmark } from "react-icons/fa6";
import '../../styles/modal.css';

const Modal = ({
    isVisible = false,
    title,
    children,
    footer,
    onClose,
    closeOnBackdrop = true,
    closeOnEscape = true
}) => {
    useEffect(() => {
        console.log(`Modal isVisible: ${isVisible}, closeOnEscape: ${closeOnEscape}`);
        
        if (!isVisible || !closeOnEscape) return;
        const keydownHandler = ({ key }) => {
            if (key === 'Escape') onClose();
        };
        document.addEventListener('keydown', keydownHandler);
        return () => document.removeEventListener('keydown', keydownHandler);
    }, [isVisible, closeOnEscape, onClose]);

    if (!isVisible) return null;

    return (
        <div
            className="modal"
            onClick={closeOnBackdrop ? onClose : undefined}
        >
            <div
                className="modal__dialog"
                onClick={e => e.stopPropagation()}
            >
                <div className="modal-header">
                    <h3 className="modal__dialog--title">{title}</h3>
                    <span className="modal__dialog--close" onClick={onClose}>
                        <FaCircleXmark />
                    </span>
                </div>
                <div className="modal-body">
                    <div className="modal-content">{children}</div>
                </div>
                {footer && <div className="modal__dialog--footer">{footer}</div>}
            </div>
        </div>
    );
};

export default Modal;